module.exports = __webpack_public_path__ + "img/wx-pay-use.52ecad42.jpg";